"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProjectMemberApi = void 0;
exports.createProjectMemberApi = (axios) => ({
    createProjectMember(_a) {
        var { projectId } = _a, rest = __rest(_a, ["projectId"]);
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`/project/${projectId}/member`, rest)).data;
        });
    },
    updateProjectMember({ projectId, userId, projectMemberRoleId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.put(`/project/${projectId}/member/${userId}`, {
                projectMemberRoleId,
            })).data;
        });
    },
    deleteProjectMember({ projectId, userId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.delete(`/project/${projectId}/member/${userId}`);
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdE1lbWJlckFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hcGkvcHJvamVjdE1lbWJlckFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdhLFFBQUEsc0JBQXNCLEdBQUcsQ0FBQyxLQUFvQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3pELG1CQUFtQixDQUFDLEVBV3pCO1lBWHlCLEVBQ3hCLFNBQVMsT0FVVixFQVRJLElBQUksY0FGaUIsYUFHekIsQ0FEUTs7WUFVUCxPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsSUFBSSxDQUFDLFlBQVksU0FBUyxTQUFTLEVBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7O0tBQ3RFO0lBRUssbUJBQW1CLENBQUMsRUFDeEIsU0FBUyxFQUNULE1BQU0sRUFDTixtQkFBbUIsR0FLcEI7O1lBQ0MsT0FBTyxDQUNMLE1BQU0sS0FBSyxDQUFDLEdBQUcsQ0FBQyxZQUFZLFNBQVMsV0FBVyxNQUFNLEVBQUUsRUFBRTtnQkFDeEQsbUJBQW1CO2FBQ3BCLENBQUMsQ0FDSCxDQUFDLElBQUksQ0FBQztRQUNULENBQUM7S0FBQTtJQUVLLG1CQUFtQixDQUFDLEVBQ3hCLFNBQVMsRUFDVCxNQUFNLEdBSVA7O1lBQ0MsTUFBTSxLQUFLLENBQUMsTUFBTSxDQUFDLFlBQVksU0FBUyxXQUFXLE1BQU0sRUFBRSxDQUFDLENBQUM7UUFDL0QsQ0FBQztLQUFBO0NBQ0YsQ0FBQyxDQUFDIn0=